// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2mlv3","box":"WorkspacesBox_box__2mQTD","node":"WorkspacesBox_node__29ZbN"};